//Copyright.js
import React from 'react'
import { Text, View } from 'react-native'
import styles from './Styles.js'

const border = 1;

const Copyright = () => {
  return (
    <View style={styles.copyright}>
      <Text style={styles.titleTextBlack}>{'\u00A9'}2021. Marcio Adriano Seno.</Text>
    </View>
  )
};
export default Copyright;
